<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div class="row items-center">
        <div class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Lista de Tablets Cadastrados
        </div>
      </div>
    </div>
    <div class="q-ml-md">
      <div class="q-mt-xl">
        <div>
          <q-btn
            no-caps
            style="border-radius: 8px; background-color: #304f78; color: white"
            icon="done"
            label="Cadastrar Tablet"
            @click="(acoesModal.cadastrar = true), (rightDrawerOpen = true)"
          />
        </div>
      </div>
    </div>
    <div class="col-12 q-mt-xl">
      <!-- <div
        class="row col-12 q-gutter-sm text-brand-1 text-weight-bold q-ml-sm items-center q-my-md"
      >
        <div class="col-2">
          <div class="q-ml-sm">Unidade</div>
          <UnidadeSelect v-model="unidade" />
        </div>
      </div> -->
      <q-table
        :columns="columns"
        :rows="listaTablets"
        table-header-style="background-color: #d9effc"
        :hide-bottom="listaTablets.length > 0"
        flat
        dense
      >
        <template #body-cell-identificador="props">
          <q-td>
            {{ props.row.identificador }}
          </q-td>
        </template>
        <template #body-cell-unidade="props">
          <q-td>
            {{ props.row.unidade }}
          </q-td>
        </template>
        <template #body-cell-imei="props">
          <q-td>
            {{ props.row.imei }}
          </q-td>
        </template>
        <template #body-cell-tipoMaquina="props">
          <q-td>
            {{ props.row.tipoMaquina }}
          </q-td>
        </template>
        <template #body-cell-credenciais="props">
          <q-td>
            <q-btn
              icon="sym_o_key"
              flat
              round
              color="black"
              @click="
                (tablet = { ...props.row }),
                  (rightDrawerOpen = true),
                  (acoesModal.credenciais = true)
              "
            />
          </q-td>
        </template>
        <template #body-cell-configurarMaquina="props">
          <q-td>
            <q-btn
              icon="sym_o_settings"
              flat
              round
              color="black"
              @click="
                (tablet = { ...props.row }),
                  (rightDrawerOpen = true),
                  (acoesModal.configuracoes = true)
              "
            />
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="rightDrawerOpen" backdrop-filter="blur(100px)">
      <q-card
        style="width: 100%"
        class="my-card row justify-between text-brand-1 text-weight-bold"
      >
        <div>
          <div class="q-pa-sm">
            <div class="text-subtitle1 text-brand-1 text-weight-bold">
              {{
                acoesModal.cadastrar
                  ? "Cadastrar Tablet"
                  : acoesModal.credenciais
                  ? `Credenciais Tablet: #${tablet?.identificador}`
                  : acoesModal.configuracoes
                  ? `Configurações Tablet: #${tablet?.identificador}`
                  : ""
              }}
            </div>
          </div>

          <q-separator />

          <q-card-section class="q-pt-xs">
            <q-form ref="myForm" v-if="acoesModal.cadastrar">
              <div class="row col-12 q-col-gutter-sm">
                <div class="col-6">
                  <div>Identificador</div>
                  <q-input
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    v-model="criarTablet.identificador"
                    dense
                    outlined
                    hide-bottom-space
                  />
                </div>
                <div class="col-6">
                  <div>Unidade</div>
                  <UnidadeSelect
                    :validacao="true"
                    v-model="criarTablet.unidade"
                    hide-bottom-space
                  />
                </div>
                <div class="col-6">
                  <div>IMEI</div>
                  <q-input
                    :rules="[(val) => !!val || 'Campo Obrigatório']"
                    v-model="criarTablet.imei"
                    dense
                    outlined
                    hide-bottom-space
                  />
                </div>
              </div>
            </q-form>

            <div v-if="acoesModal.configuracoes">
              <div class="row col-12 q-col-gutter-sm">
                <div class="col-12">
                  <div>Tipo Maquina</div>
                  <q-select
                    v-model="tablet.tipoMaquina"
                    :options="optionsTipoMaquina"
                    dense
                    outlined
                    map-options
                    label="Selecione o tipo de máquina."
                  />
                </div>
              </div>
              <FormSchema
                class="q-mt-md row col-12"
                v-if="
                  (tablet.tipoMaquina != undefined ||
                    tablet.tipoMaquina?.value != undefined) &&
                  form.schema.length > 0
                "
                :schema="form?.schema"
                :valuesSchema="form?.values"
                :verificar="validar"
                @valido="salvarOpcoesMaquina"
              />
            </div>
            <div
              v-if="acoesModal.credenciais"
              class="row col-12 q-col-gutter-sm"
            >
              <div class="col-6">
                <div>Api Key</div>
                <q-input
                  v-model="tablet.apiKey"
                  readonly
                  dense
                  outlined
                  :type="tablet.esconderApiKey ? 'password' : 'text'"
                >
                  <template v-slot:append>
                    <q-icon
                      :name="
                        tablet.esconderApiKey ? 'visibility_off' : 'visibility'
                      "
                      class="cursor-pointer"
                      @click="tablet.esconderApiKey = !tablet.esconderApiKey"
                    />
                  </template>
                </q-input>
              </div>
              <div class="col-6">
                <div>Api Secret</div>
                <q-input
                  v-model="tablet.apiSecret"
                  readonly
                  dense
                  outlined
                  :type="tablet.esconderApiSecret ? 'password' : 'text'"
                >
                  <template v-slot:append>
                    <q-icon
                      :name="
                        tablet.esconderApiSecret
                          ? 'visibility_off'
                          : 'visibility'
                      "
                      class="cursor-pointer"
                      @click="
                        tablet.esconderApiSecret = !tablet.esconderApiSecret
                      "
                    />
                  </template>
                </q-input>
              </div>
            </div>
          </q-card-section>
        </div>
        <div class="row col-12">
          <div
            v-if="!acoesModal.credenciais"
            class="row col-12 justify-end q-gutter-x-sm q-pa-sm"
          >
            <q-btn
              v-close-popup
              color="red"
              icon="sym_o_close"
              outline
              label="Cancelar"
              no-caps
              style="border-radius: 8px"
            />
            <q-btn
              v-if="acoesModal.cadastrar"
              icon="sym_o_done"
              no-caps
              style="
                border-radius: 8px;
                background-color: #304f78;
                color: white;
              "
              label="Cadastrar"
              @click="cadastrarTablet"
            />
            <q-btn
              v-if="acoesModal.configuracoes"
              icon="sym_o_done"
              no-caps
              :disable="
                tablet.tipoMaquina == undefined &&
                tablet.tipoMaquina?.value == undefined &&
                form.schema.length > 0
              "
              style="
                border-radius: 8px;
                background-color: #304f78;
                color: white;
              "
              label="Salvar"
              @click="validar++"
            />
          </div>
        </div>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import UnidadeSelect from "../../../components/unidade/UnidadeSelect.vue";

import FormSchema from "../../../components/formBuilder/Form.vue";
const columns = [
  {
    name: "identificador",
    label: "Identificador",
    align: "left",
  },
  {
    name: "unidade",
    label: "Unidade",
    align: "left",
  },
  {
    name: "imei",
    label: "IMEI",
    align: "left",
  },
  {
    name: "tipoMaquina",
    label: "Tipo Máquina",
    align: "left",
  },
  {
    name: "credenciais",
    label: "Credenciais",
    align: "left",
  },
  {
    name: "configurarMaquina",
    label: "Configurar Máquina",
    align: "left",
  },
];

const store = useStore();
const quasar = useQuasar();

// const unidade = ref("");
const rightDrawerOpen = ref(false);
const listaTablets = ref([]);
const acoesModal = ref({
  cadastrar: false,
  credenciais: false,
  configuracoes: false,
});
const criarTablet = ref({
  identificador: "",
  unidade: "",
  imei: "",
});
const tablet = ref();
const optionsTipoMaquina = ref([
  {
    label: "Balcão",
    value: "balcao",
  },
]);
const myForm = ref(null);
const form = ref({
  schema: [],
  values: {},
});
const validar = ref(0);

const listarTabletsCadastrados = async () => {
  try {
    const response = await store.dispatch(
      "refactorTablet/listarTabletsCadastrados"
    );
    listaTablets.value = response.map((value) => {
      value.esconderApiSecret = true;
      value.esconderApiKey = true;
      return value;
    });
  } catch (error) {
    console.log(error);
  }
};

const cadastrarTablet = async () => {
  let erro = false;
  await myForm.value.validate(true).then((success) => {
    if (!success) {
      erro = true;
      return;
    }
  });

  if (erro) {
    return;
  }

  try {
    const response = await store.dispatch("refactorTablet/cadastrarTablet", {
      identificador: criarTablet.value.identificador,
      unidade: criarTablet.value.unidade?.id,
      imei: criarTablet.value.imei,
    });
    listarTabletsCadastrados();
    tablet.value = response;
    tablet.value.esconderApiKey = true;
    tablet.value.esconderApiSecret = true;
    resetarValores();
    alterarModal("credenciais");
    quasar.notify({
      message: "Tablet cadastrado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro ao cadastrar tablet.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const resetarValores = () => {
  acoesModal.value = {
    cadastrar: false,
    credenciais: false,
    configuracoes: false,
  };

  criarTablet.value = {
    unidade: "",
    identificador: "",
    imei: "",
  };
};

const detalharConfiguracaoMaquina = async () => {
  try {
    const response = await store.dispatch(
      "refactorTablet/detalharConfiguracaoMaquina",
      {
        tipoMaquina: tablet.value.tipoMaquina,
      }
    );
    form.value = {
      schema: response.schema,
      values: response.values,
    };
  } catch (error) {
    console.log(error);
  }
};

const alterarModal = (nomeModal) => {
  for (const key in acoesModal.value) {
    if (key != nomeModal) {
      acoesModal.value[key] = false;
    } else {
      acoesModal.value[key] = true;
    }
  }
};

const salvarOpcoesMaquina = async (values) => {
  try {
    await store.dispatch("refactorTablet/salvarOpcoesMaquina", {
      identificador: tablet.value.identificador,
      values: values,
    });
    quasar.notify({
      message: "Opçoẽs de máquina salvas com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    rightDrawerOpen.value = false;
    listarTabletsCadastrados();
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro ao salvar opçoes de máquina.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

watch(
  () => rightDrawerOpen.value,
  () => {
    if (!rightDrawerOpen.value) {
      resetarValores();
    }
  }
);

watch(
  () => tablet.value?.tipoMaquina,
  () => {
    if (rightDrawerOpen.value && acoesModal.value.configuracoes) {
      detalharConfiguracaoMaquina();
      return;
    }
    form.value = {
      schema: {},
      values: {},
    };
  }
);

onMounted(() => {
  listarTabletsCadastrados();
});
</script>

<style scoped></style>
